module.exports = __webpack_public_path__ + "static/media/shape2.pngfeat0.b898b0fe.png";